import { Link, useLocation, useNavigate } from 'react-router-dom';
import './hamburger-menu.css';
import Cookies from 'js-cookie';
import { useContext, useState } from 'react';
import { cartContext } from '../App';

export default function HamburgerMenu() {
    const navigate = useNavigate();
    const location = useLocation();
    const { CartItem, deferredPrompt, showDownloadButton, changeInstallVariable } = useContext(cartContext)
    const [userId, setUserId] = useState(JSON.parse(localStorage.getItem('userId')) || null);

    function back() {
        navigate(-1);
    }

    const address = Cookies.get('address');
    const add = address && address !== 'undefined' ? address : 'Select Address';
    let name = 'Guest'
    if (add !== 'Select Address' && add !== 'unserviceable') {
        name = add.split(',')[0]
    }

    function share() {
        if (navigator.share) {
            navigator.share({
                title: 'OnTimeUrban - The Instant Wholesaler | Hazaribagh',
                text: 'Check out OnTimeUrban for groceries and gadgets delivered in just 15 minutes!',
                url: 'https://www.ontimeurban.com',
            })
        } else {
            alert('Sharing is not supported by browser.')
        }
    }

    const handleAddToHomeScreen = () => {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User added the app to their home screen');
            } else {
              console.log('User dismissed the prompt');
            }
              changeInstallVariable();
          });
        }
    };
    
    function handleLogout() {
        localStorage.removeItem('userId');
        setUserId(null)
    }

    return (
        <div className='hamburger-box'>
            <div className='hamburger-open-icon' >
                <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <img src='/icons/left-arrow.png' alt='back' style={{width:'20px', height:'20px', marginRight:'10px'}} onClick={back}/>
                    <img src='/icons/profile-user.png' alt='close' style={{ width: '30px', height: '30px' }} />

                    {
                        userId ? (
                            <p style={{marginLeft:'10px', color:'#2C5F2D', fontWeight:'500'}}><span style={{color:'black'}}>Hello,</span> {userId}</p>
                        ) : (
                            <div style={{marginLeft:'10px', backgroundColor:'#2c5f2d', borderRadius:'5px', padding:'7px 10px'}}>
                                <Link to='/login' style={{color:'white', textDecoration:'none'}}>LOGIN/SIGNUP</Link>
                            </div>
                        )
                    }
                        
                </div>
                <div className='close-icon'><img src='/icons/close.png' alt='close' style={{width:'20px', height:'20px', border:'0.15px solid #2c5f2d', borderRadius:'50%', padding:'7px', backgroundColor:'rgb(237, 243, 234)'}} onClick={back}/></div>
            </div>
            <div className='hamburger-true'>
                <div className='icons-row-box'>
                    <Link to='/' style={{textDecoration:'none'}}>
                        <div className='hamburger-top-icons'>
                            <img src='/icons/home.png' alt='home' style={{height:'30px', width:'30px'}}/>
                            <p style={{margin:'5px', color:'#2C5F2D', fontWeight:'500'}}>Home</p>
                        </div>
                    </Link>
                    <Link to='/orders' style={{textDecoration:'none'}}>
                        <div className='hamburger-top-icons'>
                            <img src='/icons/package.png' alt='home' style={{height:'30px', width:'30px'}} />
                            <p style={{margin:'5px', color:'#2C5F2D', fontWeight:'500'}}>Orders</p>
                        </div>
                    </Link>
                    <Link to='/cart' style={{textDecoration:'none'}}>
                        <div className='hamburger-top-icons'>
                            {/* <img src='/shopping-cart.png' alt='home' style={{height:'30px', width:'30px'}} /> */}
                            <div className='cart-item-number'>
                                <span className='item-number'>{ CartItem.length }</span>
                                    <img className='cart-logo' src='/shopping-cart.png' />
                                </div>
                            <p style={{margin:'5px', color:'#2C5F2D', fontWeight:'500'}}>Cart</p>
                        </div>
                    </Link>
                </div>
                
                <div className='hamburger-middle-box'>
                    <Link to='/address-list' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/address.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Address</p>
                        </div>
                    </Link>
                    {/* <Link to='/search' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/search.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Search</p>
                        </div>
                    </Link> */}
                    <a target='blank' href='https://wa.me/message/3ZEPUXZXOKU5I1' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/communications.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Chat with Us</p>
                        </div>
                    </a>
                    <div className='hamburger-middle-list' onClick={share}>
                        <img src='/icons/share.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                        <p style={{ color:'black', fontWeight:'500'}}>Share with Friends</p>
                    </div>
                    <Link to='/contact-us' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/support.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Contact Us</p>
                        </div>
                    </Link>
                    <Link to='/about-us' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/about-us.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>About Us</p>
                        </div>
                    </Link>
                    <a target='blank' href='https://g.page/r/CStClaj51bCbEBM/review' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/rate.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Rate Us</p>
                        </div>
                    </a>
                    
                    <Link to='/privacy-policy' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/privacy-policy.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/>
                            <p style={{ color:'black', fontWeight:'500'}}>Privacy Policy</p>
                        </div>
                    </Link>
                    <Link to='/terms-and-conditions' style={{textDecoration:'none'}}>
                        <div className='hamburger-middle-list'>
                            <img src='/icons/terms.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/> 
                            <p style={{ color:'black', fontWeight:'500'}}>Terms and Conditions</p>
                        </div>
                    </Link>
                    {
                        userId && 
                        (
                            <>
                                <div className='hamburger-middle-list' onClick={handleLogout}>
                                    <img src='/icons/logout.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/> 
                                    <p style={{ color:'#E04F5F', fontWeight:'500'}}>LOGOUT</p>
                                </div>
                                <Link to='/delete-account' style={{textDecoration: 'none'}} className='hamburger-middle-list'>
                                    <img src='delete.png' alt='address-logo' style={{height:'25px', width:'25px', marginRight:'5px'}}/> 
                                    <p style={{ color:'#E04F5F', fontWeight:'500'}}>Account deletion</p>
                                </Link>
                            </>
                        )
                    }
                </div>
                <div className='footer-section'>
                    <div>
                        <p style={{color:'black', fontSize:'18px', fontWeight:'bold', marginBottom: '5px', marginTop: '5px'}}>Download OnTimeUrban app</p>
                        <p style={{ color: 'black', fontSize: '13px', marginTop: '5px', fontSize: '12px' }}>
                            Download our app now and enjoy <span style={{fontWeight: 'bold'}}>10% OFF with code APP10</span>, lightning-fast checkout, and a smoother shopping journey.
                        </p>
                        <Link to='https://play.google.com/store/apps/details?id=com.otu_android' style={{textDecoration: 'none'}}><div className="app-download-btn">Download</div></Link>
                    </div>
                    <div>
                        <img src='/icons/add-product.png' alt="Request-Product" style={{height:'150px'}}/>
                    </div>
                </div>
                <div>
                    <p style={{ textAlign: 'center', margin:'5px' }}>Version 1.5.7</p>
                </div>
            </div>    
        </div>
    );

}